import { render, staticRenderFns } from "./SimpleFormModal.vue?vue&type=template&id=df72361e&scoped=true&"
import script from "./SimpleFormModal.vue?vue&type=script&lang=js&"
export * from "./SimpleFormModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFormModal.vue?vue&type=style&index=0&id=df72361e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df72361e",
  null
  
)

export default component.exports